import { render, staticRenderFns } from "./BiographyPortrait.vue?vue&type=template&id=71914606&scoped=true&"
import script from "./BiographyPortrait.vue?vue&type=script&lang=js&"
export * from "./BiographyPortrait.vue?vue&type=script&lang=js&"
import style0 from "./BiographyPortrait.vue?vue&type=style&index=0&id=71914606&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71914606",
  null
  
)

component.options.__file = "BiographyPortrait.vue"
export default component.exports